export const BILLING_STATUS_LABELS = {
    approved: "Paga",
    pending: "Pendente",
    rejected: "Recusada",
    cancelled: "Cancelada",
    in_process: "Processando",
};

export const BILLING_STATUS_COLORS = {
    approved: "success",
    pending: "warning",
    rejected: "danger",
    cancelled: "muted",
    in_process: "info",
};

export const STATUS_FILTER_OPTIONS = [
    { value: "all", label: "Todos os Status" },
    { value: "approved", label: "Pagas" },
    { value: "pending", label: "Pendentes" },
    { value: "rejected", label: "Recusadas" },
];
